export const environmentTypes = Object.freeze({
    DEV: 'dev',
    ACCOUNTZONTRACK: 'accountzontrack',
    SREC: 'srec',
    MUTHAYAMMAL: 'muthayammal',
    TAGOREIET: 'tagoreiet',
    YI: 'yi'
});

export const environmentName = environmentTypes.DEV;

export const ROLE = {
    ADMIN: 3,
    ASSESSOR: 4,
    ASSESSE: 5,
    ACADEMICCOUNCIL: 6
};

export const PASS_PERCENTAGE = true;